import type { GetTeamsCountsResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

const getTeamsCountsQueryKeyFactory = {
  all: () => ["teams", "counts"] as const,
};

async function getTeamsCounts(): Promise<GetTeamsCountsResponse> {
  return apiClient.url("/teams/counts").get().json();
}

interface UseGetTeamsCountsParams {
  enabled?: boolean;
}

export function useGetTeamsCounts(params: UseGetTeamsCountsParams = {}) {
  const { enabled = true } = params;

  return useQuery({
    enabled,
    queryFn: getTeamsCounts,
    queryKey: getTeamsCountsQueryKeyFactory.all(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export { getTeamsCountsQueryKeyFactory };
